import {Component, HostListener, OnInit} from '@angular/core';
import {FooterService} from '../../../services/footer.service';

@Component({
  selector: 'app-objects-measurement',
  templateUrl: './objects-measurement.component.html',
  styleUrls: ['./objects-measurement.component.css']
})
export class ObjectsMeasurementComponent implements OnInit {

  footerHeight: number;

  constructor(private footerService: FooterService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    setTimeout(() => {
      this.footerHeight = this.footerService.getFooterHeight();
    }, 500);
  }

  ngOnInit(): void {
    this.footerHeight = this.footerService.getFooterHeight();
  }
}
